module.exports = __webpack_public_path__ + "static/customer_sushi_swap_logo-b77923bdec58ed5e3cfef98a04353a91.svg";